import { useMemo } from "react";
import { Select } from "@narmi/design_system";
import { useTranslatedDueDateOptions } from "byzantine/src/dbbl/businessLogic/modules/alerts";

export interface DueDateSelectorProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  errorText?: string;
}

export default function DueDateSelector({
  label,
  value,
  onChange,
  error,
  errorText,
}: DueDateSelectorProps) {
  const options = useTranslatedDueDateOptions();

  const renderedOptions = useMemo(
    () =>
      options.map((option) => (
        <Select.Item
          key={option.id}
          value={option.id}
          searchValue={option.displayValue}
          tokenLabel={option.displayValue}
        >
          {option.displayValue}
        </Select.Item>
      )),
    [options]
  );

  return (
    <Select
      id="due-date-select"
      label={label}
      value={value}
      defaultValue={value}
      onChange={onChange}
      errorText={errorText || error}
    >
      {renderedOptions}
    </Select>
  );
}
